// extracted by mini-css-extract-plugin
module.exports = {"imgRow":"components-TasteCard2-TasteCard2Image-TasteCard2Image__imgRow--3YNzo"};